import authenticationModule from "./authenticationModule"

authenticationModule.controller("authenticationController", ["$scope", "authenticationService", "$state", "passwordModalService", ($scope, authenticationService, $state, passwordModalService) => {

    $scope.credentials = {
        tenantId: authenticationService.getTenantId()
    }
    $scope.hasToShow = false
    $scope.currentYear = new Date().getFullYear()

    function followToUrl() {
        var targetUrl = authenticationService.getTargetState()
        if (targetUrl) {
            $state.go(targetUrl, authenticationService.getTargetStateParams())
        } else {
            $state.go($scope.loginState)
        }
    }

    if (authenticationService.isAuthenticated()) {
        authenticationService.validateToken()
            .then(followToUrl)
    }

    $scope.authenticate = function () {
        authenticationService.authenticate($scope.credentials.username, $scope.credentials.password, $scope.credentials.tenantId)
            .then(followToUrl)
            .then(function () {
                passwordModalService.openExpiredPasswordWarningModal($scope.credentials)
            })
            .catch((response) => {
                var errors = response.data
                if (response.status === 401) {
                    authenticationService.isUserExists($scope.credentials.username, $scope.credentials.password)
                        .then((isExpired) => {
                                if (isExpired) {
                                    passwordModalService.openChangePasswordModal($scope.credentials)
                                }
                            }
                        )
                        .catch(() => {
                            return $scope.errorMessages = [{keyBundle: "messages.authentication.userOrPasswordInvalid"}]
                        })
                    return $scope.errorMessages = [{keyBundle: "messages.authentication.accountExpiredException"}]
                }
                if (response.status === 403) {
                    return $scope.errorMessages = errors?.keyBundle ? [errors] : [{keyBundle: "messages.authentication.accessDenied"}]
                }
                if (response.status === 504) {
                    return $scope.errorMessages = [{keyBundle: "messages.authentication.connectionError"}]
                }
                $scope.errorMessages = [{keyBundle: "logging.error.msg.SystemError"}]
            })
    }

    $scope.hidePassword = () => {
        $scope.hasToShow = !$scope.hasToShow
    }

    $scope.getInputType = () => {
        if ($scope.hasToShow) {
            return "text"
        }
        return "password"
    }

    $scope.getEyeClass = () => {
        if ($scope.hasToShow) {
            return "fa fa-eye"
        }
        return "fa fa-eye-slash"
    }


}])